// eslint-disable-next-line no-unused-vars
export default function preloaderGameOver (scene) {

	// TODO

}